/**
 * status.ts
 *
 * Pure helpers for Title Analysis polling and status decisions.
 *
 * - Run control helpers: whether the "Run Title Analysis" button should be disabled.
 *
 * Requirements: 18.4, 18.6, 18.8
 */

export type TitleAnalysisStatus = 'pending' | 'in_progress' | 'completed' | 'failed';

export function isTitleAnalysisRunStale(
  startedAtSeconds: number | null,
  staleAfterSeconds: number,
  nowMs: number
): boolean {
  if (startedAtSeconds == null) return true;
  return nowMs / 1000 - startedAtSeconds > staleAfterSeconds;
}

/**
 * Determine whether the "Run Title Analysis" control should be disabled.
 *
 * The control is disabled when:
 * - No use case is selected (a use case is required to start analysis), OR
 * - A request is pending (e.g., the route has been called but we haven't yet
 *   observed the transition to `in_progress`).
 *
 * @param selectedUseCase The currently selected use case, or `null` if none.
 * @param isRequestPending Whether a start request is in flight.
 * @returns `true` to disable the control, `false` to enable it.
 *
 * Requirements: 18.6 (run control disabled when no use case or request pending).
 */
export function isRunControlDisabled(
  selectedUseCase: string | null,
  isRequestPending: boolean
): boolean {
  return !selectedUseCase || isRequestPending;
}
